export const ITEMS_PER_PAGE = 10;

export const CHARGER_LIST_COLUMN_DATA = [
  {
    label: "Image",
    field: "image",
    sort: "asc",
    width: 20,
  },
  {
    label: "Status",
    field: "status",
    sort: "asc",
    width: 40,
  },
  {
    label: "Charger ID",
    field: "chargerId",
    sort: "asc",
    width: 50,
  },
  {
    label: "Power",
    field: "rating",
    sort: "asc",
    width: 28,
  },
  {
    label: "Per Unit Rate",
    field: "unitRate",
    sort: "asc",
    width: 32,
  },
  {
    label: "Vendor Id",
    field: "vendorId",
    sort: "asc",
    width: 28,
  },
  {
    label: "Model Type",
    field: "modelType",
    sort: "asc",
    width: 70,
  },
  {
    label: "Protocol Type",
    field: "protocolType",
    sort: "asc",
    width: 70,
  },
  // {
  //   label: "No of Connectors",
  //   field: "connectors",
  //   sort: "asc",
  //   width: 28,
  // },
  {
    label: "Firmware Version",
    field: "firmwareVersion",
    sort: "asc",
    width: 24,
  },
];

export const CURRENCY_MAP = {
  Rupee: "₹",
  USD: "$",
  Euro: "€",
  Pound: "£",
  AED: "د.إ",
};

export const LATEST_TRANSACTION_LOG_COLUMN_DATA = [
  {
    dataField: "id",
    text: "No.",
  },
  {
    dataField: "transactionId",
    text: "Transaction ID",
  },
  {
    dataField: "orderId",
    text: "Charger ID",
  },
  {
    dataField: "conn",
    text: "Conn",
  },
  {
    dataField: "date",
    text: "Date & Time",
  },
  {
    dataField: "billingName",
    text: "UserId (RFID)",
  },
  {
    dataField: "total",
    text: "Total ( \u20B9 )",
  },
  {
    dataField: "consumption",
    text: "kWh",
  },
  {
    dataField: "status",
    text: "Payment Status",
  },
];

export const LATEST_FAULT_LOG_COLUMN_DATA = [
  {
    dataField: "id",
    text: "No.",
  },

  {
    dataField: "connId",
    text: "Conn",
  },
  {
    dataField: "chargerId",
    text: "Charger ID",
  },
  {
    dataField: "timeStamp",
    text: "Date & Time",
  },
  {
    dataField: "details",
    text: "Details",
  },
];

export const VENDOR_ID = "LauritzKnudsen";
export const INUSE_CHARGER_STATUS = ["preparing", "charging", "finishing", "suspendedev", "suspendedevs"];

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const amenitiesOptions = [
  { value: "Parking", label: "Parking" },
  { value: "Restaurant", label: "Restaurant" },
  { value: "Restroom", label: "Restroom" },
];

export const connectorsOptions = [
  { value: "type2", label: "Type-2 Connector" },
  { value: "industrialSocket", label: "Industrial Socket" },
  { value: "ccs2", label: "CCS2" },
  { value: "plugSocket", label: "Plug Socket" },
];

export const modelTypeOptions = [
  { value: "AC", label: "AC" },
  { value: "DC", label: "DC" },
  { value: "Combo", label: "Combo" },
];

export const powerRatingOptions = [
  { value: "3.3", label: "3.3kW" },
  { value: "7.4", label: "7.4kW" },
  { value: "22", label: "22kW" },
];

export const REPORT_DETAILS = [
  {
    name: "Revenue vs Expense",
    value: "rve",
    isSelected: true,
    description: "This report provides a comparison between your business's revenue and its expenses(Energy expense, Maintenance charges and misc). ",
    icon: "ri-download-fill",
  },
  {
    name: "Energy",
    value: "en",
    isSelected: true,
    description: "The Energy Report tracks the consumption of energy and provide the total energy consumption.",
    icon: "ri-download-fill",
  },
  {
    name: "Capacity Utilization",
    value: "cu",
    isSelected: true,
    description: "This report evaluates how effectively the chargers time occupation and energy utilization.",
    icon: "ri-download-fill",
  },
  // This report evaluates how effectively a company's production capacity is being used. This report is generated based on time and energy utilization.
  { name: "RFID", value: "rfid", isSelected: true, description: "This report provides charging and transaction details of the RFID card holders.", icon: "ri-download-fill" },
  {
    name: "Transaction and Revenue",
    value: "tar",
    isSelected: true,
    description: "The Transaction and revenue Report provides a detailed overview of transactions conducted and revenue obtained over a specific period. ",
    icon: "ri-download-fill",
  },
];
